import { defineMessages } from "react-intl";

/** Přístupnostní popisky lišty nad jednotkou popisu. */
export const toolbarMessages = defineMessages({
    mainToolbar: { id: "arr.node.toolbar.main", defaultMessage: "Nástroje jednotky popisu" },
    viewSettings: { id: "arr.node.toolbar.viewSettings", defaultMessage: "Nastavení zobrazení" },
    moreItems: { id: "arr.node.toolbar.moreItems", defaultMessage: "Další položky" },
});
